import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import GoToButton from '../CustomButtons/GoToButton'

const ActivityButtons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;

  @media (max-width: 763px) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  ${({ isActivityInProgress }) => isActivityInProgress && css`
    margin: 70px 0 0;
  `}
`
const ActivityButton = styled(GoToButton)`
  width: 100% !important;
  color: red !important;
`

class RegisterActivity extends Component {
  goTo = (name, category) => {
    const {
      goToView,
      setExtraData,
      view,
    } = this.props

    goToView(name, view, category)
    setExtraData({})
  }

  renderActivityButtons = () => {
    const {
      activityAlreadyInProgress,
      categories: activities,
      child,
      activeClassroom,
    } = this.props
    if(activities.length === 0){
      return null;
    }
    return activities.map((category) => {
      if (activeClassroom.type === 'External' && activeClassroom.name === 'Advenio Externo') {
        if (category.name === 'Nap' || category.name === 'Incident') {
          return null
        }
      }

      if ((activityAlreadyInProgress && category.name !== 'Photo') || category.name === 'Incident') {
        return null
      }

      let label = category.translations.es

      if (!child.uses_diapers && category.name === 'Diaper') {
        label = 'Visita al baño'
      }

      return (
        <ActivityButton
          key={category.id}
          icon="/assets/Apple.svg"
          label={label}
          onButtonClick={() => this.goTo(category.name, category.id)}
          id={category.id}
          childrenList
        />
      )
    })
  }

  render() {
    return (
      <ActivityButtons isActivityInProgress={this.props.activityAlreadyInProgress}>
        {this.renderActivityButtons()}
      </ActivityButtons>
    )
  }
}

RegisterActivity.propTypes = {
  /** Flag marking if an activity is already in progress for the given student */
  activityAlreadyInProgress: PropTypes.bool,
  /** The listing of available activities that can be registered */
  categories: PropTypes.array,
  /** The child to whom the activity is being registered */
  child: PropTypes.object,
  /** The view to be displayed */
  view: PropTypes.string,

  /** Callback function to navigate to the specified view */
  goToView: PropTypes.func.isRequired,
  /** Callback function to retrieve information */
  setExtraData: PropTypes.func.isRequired,
}

RegisterActivity.defaultProps = {
  activityAlreadyInProgress: false,
  categories: [],
  child: {},
  view: '',
}

export default RegisterActivity



// WEBPACK FOOTER //
// ./src/Components/Activity/RegisterActivity.jsx